import React, { useState, useEffect } from "react"
import {
  footerNewsletter,
  footerNewsletterInput,
  footerCheckboxContainer,
  sectionAlertModal,
  sectionAlert,
  sectionAlertHeader,
  sectionAlertContent,
  sectionAlertButton,
  sectionAlertTitle,
} from "./inscriptionNewsletter.module.scss"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import {
  FooterNewsletter,
  Title,
  SectionAlert,
  SectionAlertButton,
  SectionAlertContent,
  ColoredDiv,
} from "./inscription-newsletter-styled"
import PropTypes from "prop-types"
import { useNewsletter } from "gatsby-theme-blank/src/components/InscriptionNewsletter/inscription-newsletter-query"

const InscriptionNewsletter = ({ hasBorderRight }) => {
  const [newsletterResult, setNewsletterResult] = useState([])
  const [showResult, setShowResult] = useState(false)
  const [newsletters, setNewsletters] = useState(
    useNewsletter().newsletters.newsletters
  )

  // Initialisation des états des newsletters / checkboxes
  useEffect(() => {
    if (!newsletters) {
      setNewsletters([])
      return
    }
    const initNewsletters = [...newsletters]
    for (const index in initNewsletters) {
      initNewsletters[index].state = false
    }
    setNewsletters(initNewsletters)
  }, [])

  const handleCheckboxFocus = (event) => {
    event.target.addEventListener("keydown", handleCheckboxKeydown)
  }

  function handleCheckboxBlur(event) {
    event.target.removeEventListener("keydown", handleCheckboxKeydown)
  }

  function handleCheckboxKeydown() {
    if (typeof document !== `undefined`) {
      const index = document.activeElement.getAttribute("data-index")
      if (event.key === "Enter" && index) {
        const updatedNewsletters = [...newsletters]
        updatedNewsletters[index].state = !updatedNewsletters[index].state
        setNewsletters(updatedNewsletters)
      }
    }
  }
  const handleCheckbox = (event) => {
    const index = event.target.getAttribute("data-index")
    if (index !== null) {
      const updatedNewsletters = [...newsletters]
      updatedNewsletters[index].state = !updatedNewsletters[index].state
      setNewsletters(updatedNewsletters)
    }
  }

  function subscribeNewsletter(event) {
    event.preventDefault()
    if (
      typeof document !== `undefined` &&
      document.getElementById("honeypot").checked
    )
      return
    const mail = document.getElementById("newsletter-email").value
    const emailValid = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    if (!mail || !emailValid) {
      alert("Veuillez entrer une adresse mail valide.")
      return
    }
    const baseUrl = process.env.GATSBYSIDE_DRUPAL_URL
    const promises = []
    newsletters?.map((newsletter) => {
      // Si la newsletter est cochée, on envoie une demande d'inscription
      if (newsletter.state) {
        const url =
          baseUrl + "/newsletter/subscribe/" + newsletter.id + "/" + mail
        promises.push(sendSubscribeRequest(url, newsletter))
      }
      return null
    })

    if (promises.length === 0) {
      alert("Veuillez cocher au moins une newsletter.")
      return
    }

    // Une fois que toutes les requêtes ont reçu une réponse, on affiche les résultats
    Promise.all(promises).then((results) => {
      let finalMessage = ""
      for (let index = 0; index < results.length; index++) {
        finalMessage += results[index] + "<br />"
      }
      setNewsletterResult(finalMessage)
      setShowResult(true)
    })
  }

  function sendSubscribeRequest(url, newsletter) {
    return new Promise((resolve, reject) => {
      fetch(url).then((response) => {
        const statusCodeOnMailSent = 200
        const statusCodeOnSubscribed = 201
        if (response.status === statusCodeOnSubscribed) {
          // Lorsque l'utilisateur est automatiquement inscrit
          resolve(
            "Vous avez été inscrit avec succès à la newsletter " +
              newsletter.name
          )
        } else if (response.status === statusCodeOnMailSent) {
          // Lorsqu'un mail de confirmation a été envoyé pour cette newsletter
          resolve(
            "Votre demande d'inscription à la newsletter " +
              newsletter.name +
              " a bien été prise en compte. Vous devriez recevoir un mail de confirmation à l'adresse indiquée. Vérifiez votre dossier de courrier indésirable si vous ne recevez pas le mail de validation dans votre boite de réception."
          )
        } else {
          resolve(
            "Une erreur s'est produite lors de votre demande d'inscription à la " +
              newsletter.name +
              ", veuillez réessayer ultérieurement"
          )
        }
      })
    })
  }

  if (newsletters?.length === 0) {
    return null
  }
  return (
    <>
      {showResult && (
        <div className={sectionAlertModal} role="status">
          <SectionAlert className={sectionAlert}>
            <div className={sectionAlertHeader}>
              <Title className={sectionAlertTitle}>
                Inscription à la newsletter
              </Title>
              <SectionAlertButton
                className={sectionAlertButton}
                onClick={() => {
                  setShowResult(false)
                }}
              >
                &times;
              </SectionAlertButton>
            </div>
            <SectionAlertContent className={sectionAlertContent}>
              <ContentTransformer
                content={newsletterResult}
              ></ContentTransformer>
            </SectionAlertContent>
          </SectionAlert>
        </div>
      )}
      <FooterNewsletter
        hasBorderRight={hasBorderRight}
        className={footerNewsletter}
      >
        <h2>{"S'inscrire à notre newsletter"}</h2>
        <ColoredDiv
          className={footerCheckboxContainer}
          role="group"
          aria-label="S’inscrire à la newsletter"
        >
          <ul>
            {newsletters?.map((newsletter, index) => (
              <li key={newsletter.id}>
                <label
                  htmlFor={"checkbox-" + newsletter.id}
                  tabIndex="0"
                  onClick={handleCheckbox}
                  onFocus={handleCheckboxFocus}
                  onBlur={handleCheckboxBlur}
                  data-index={index}
                >
                  <input
                    type="checkbox"
                    name={"checkbox-" + newsletter.id}
                    id={"checkbox-" + newsletter.id}
                    data-index={index}
                    checked={newsletters[index].state}
                    tabIndex="-1"
                  ></input>{" "}
                  <span>{newsletter.name}</span>
                </label>
              </li>
            ))}
          </ul>
        </ColoredDiv>
        <div className={footerNewsletterInput}>
          <input
            type="email"
            id="newsletter-email"
            name="email"
            title={"Votre adresse email"}
            placeholder="Inscrivez votre adresse mail"
            aria-label="Inscrivez votre adresse mail"
            aria-required={true}
            required={true}
            autoComplete={"email"}
          ></input>
          <button
            type="submit"
            onClick={subscribeNewsletter}
            aria-label={"Valider l'inscription"}
          >
            S&apos;inscrire
          </button>
        </div>
        <input id="honeypot" type="checkbox" tabIndex="-1" hidden />
      </FooterNewsletter>
    </>
  )
}

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

InscriptionNewsletter.propTypes = {
  hasBorderRight: PropTypes.bool,
}

//-----------------------Prop-Types---------------------------//

export default InscriptionNewsletter
